import { useState, useCallback } from 'react';
// @mui
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import ClickAwayListener from '@mui/material/ClickAwayListener';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useSnackbar } from 'notistack';
// components
import Iconify from 'src/components/iconify';
// services
import { postRequest } from 'src/services';
// endpoints
import { endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export default function KanbanColumnAdd({ reload, newcol }) {
  const [ title, setTitle ] = useState('');
  const [ limit, setLimit ] = useState(100);
  const [ order, setOrder ] = useState(newcol);
  const [ loading, setLoading ] = useState(false);

  const openAddColumn = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  const handleCreateColumn = useCallback(async () => {
    if (!title) return;

    setLoading(true);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('limit', limit);
    formData.append('order', order);

    try {
      const response = await postRequest(
        endpoints.admin_dashboard.marketing_management.board.crud_stage,
        formData,
        true
      );

      if (response.metadata?.success) {
        enqueueSnackbar({
          variant: 'success',
          message: response.metadata.message || 'Column created successfully',
        });
        setTitle('');
        setLimit('');
        setOrder('');
        reload()
      } else {
        enqueueSnackbar({
          variant: 'error',
          message: response.metadata?.message || 'Failed to create column',
        });
      }
    } catch (err) {
      console.error('Create column error:', err);
      enqueueSnackbar({
        variant: 'error',
        message: err.message || 'An error occurred while creating the column',
      });
    } finally {
      setLoading(false);
      openAddColumn.onFalse();
    }
  }, [ title, openAddColumn, enqueueSnackbar ]);

  const handleKeyUp = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        handleCreateColumn();
      }
    },
    [ handleCreateColumn ]
  );

  return (
    <Paper sx={ { minWidth: 280, width: 280 } }>
      { openAddColumn?.value ? (
        <ClickAwayListener onClickAway={ handleCreateColumn }>
          <div style={ { padding: 8 } }>
            <Button
              fullWidth
              size="large"
              color="inherit"
              variant="outlined"
              sx={ { mb: 1 } }
              startIcon={
                <Iconify
                  icon={ openAddColumn.value ? 'mingcute:arrow-left-line' : 'mingcute:add-line' }
                  sx={ { mr: -0.5 } }
                />
              }
              onClick={ openAddColumn.onToggle }
            >
              { openAddColumn.value ? 'Close' : 'Add Stage' }
            </Button>
            <TextField
              autoFocus
              fullWidth
              placeholder="Title"
              value={ title }
              onChange={ (e) => setTitle(e.target.value) }
              onKeyUp={ handleKeyUp }
              disabled={ loading }
              sx={ {
                mb: 1,
                [ `& .${inputBaseClasses.input}` ]: {
                  typography: 'h6',
                },
              } }
            />
            {/* <TextField
              fullWidth
              placeholder="Limit"
              type='number'
              value={ limit }
              onChange={ (e) => setLimit(e.target.value) }
              onKeyUp={ handleKeyUp }
              disabled={ loading }
              sx={ { mb: 1 } }
            />
            <TextField
              fullWidth
              type='number'
              placeholder="Order"
              value={ order }
              onChange={ (e) => setOrder(e.target.value) }
              onKeyUp={ handleKeyUp }
              disabled={ loading }
            /> */}
          </div>
        </ClickAwayListener>
      ) : (
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          startIcon={
            <Iconify
              icon={ openAddColumn.value ? 'mingcute:arrow-left-line' : 'mingcute:add-line' }
              sx={ { mr: -0.5 } }
            />
          }
          onClick={ openAddColumn.onToggle }
        >
          { openAddColumn.value ? 'Close' : 'Add Stage' }
        </Button>

      ) }
    </Paper>
  );
}
